import { render, staticRenderFns } from "./TestFormBuilder.vue?vue&type=template&id=441a095d&"
import script from "./TestFormBuilder.vue?vue&type=script&lang=js&"
export * from "./TestFormBuilder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports